export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};

// Get PHPSESSID token for authentication
export const getAuthToken = () => {
  return getCookie('PHPSESSID');
};